import React from 'react';

const ContactUsIcon = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.4375 1.5625H21.875V23.4375L29.6875 17.1875H48.4375V1.5625Z"
      stroke="#FA6400"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="39.0625"
      cy="28.125"
      r="4.6875"
      stroke="#404040"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="10.9375"
      cy="28.125"
      r="4.6875"
      stroke="#404040"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3125 46.875V42.2148C20.3125 41.1055 19.7305 40.0852 18.7758 39.5203C17.2563 38.6211 14.6219 37.5 10.9375 37.5C7.20547 37.5 4.58828 38.6141 3.08437 39.5117C2.1375 40.0773 1.5625 41.0945 1.5625 42.1977V46.875H20.3125Z"
      stroke="#404040"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.4375 46.875V42.2148C48.4375 41.1055 47.8555 40.0852 46.9008 39.5203C45.3813 38.6211 42.7469 37.5 39.0625 37.5C35.3305 37.5 32.7133 38.6141 31.2094 39.5117C30.2625 40.0773 29.6875 41.0945 29.6875 42.1977V46.875H48.4375Z"
      stroke="#404040"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ContactUsIcon;
